import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Prescripteur } from 'src/app/shared/models/prescripteur';
import { PARAM_LABEL_BENEFICIAIRE } from 'src/app/core/services/constant/constants.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';

@Component({
	selector: 'app-prescripteur-modal-ajout-form',
	templateUrl: './prescripteur-modal-ajout-form.component.html',
	styleUrls: ['./prescripteur-modal-ajout-form.component.scss']
})
export class PrescripteurModalAjoutFormComponent implements OnInit {
	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	isPreferencesActive = false;

	prescripteur = new Prescripteur();

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = new FormGroup({
		nomStructure: new FormControl('', [
			Validators.required,
		]),
		addressStructure: new FormControl(new Address().label),
		typeStructure: new FormControl(),
		contacts: this.fb.array([this.fb.group({
			id: '',
			lastName: '',
			firstName: '',
			telephoneFixe: '',
			telephonePortable: '',
			telephoneStandard: '',
			email: '',
			fonction: '',
		})])
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	@Output() updateListing = new EventEmitter();


	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private toastService: ToastService,
		private fb: FormBuilder
	) {}

	ngOnInit(): void {
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.facade.prescripteurService
			.addPrescripteur(this.prescripteur)
			.subscribe({
				next: (addedPrescripteurId: number) => {
					this.prescripteur.id = addedPrescripteurId;
					this.isValidateButtonClicked.value = false;
					this.bsModalRef.hide();
					this.updateListing.emit(this.prescripteur);
				},
				error: (err: ErrorResponse) => {
					this.isValidateButtonClicked.value = false;
					this.toastService.createHttpErrorToast(
						err.error.message,
						err.status
					);
				}
			});
	}
}
